import {XauditModel} from '../xaudit.model';
import {InternalEmailDestinationDataModel} from './internal-email-destination-data.model';

export class InternalEmailDataModel extends XauditModel {
  IEmailID: string;
  LOCID: number;
  SenderUserID: string;
  enumEmailBoxID: string;
  SendDateTime: Date;
  enumIEmailPriorityID: string = '00000196-1000-0000-0000-000000000001';
  enumIEmailTypeID: string = '00000198-1000-0000-0000-000000000001';
  PatientID: string;
  TextMessage: string;

  dataInternalEmailDestanations: InternalEmailDestinationDataModel[] = [];
}
